import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {injectIntl, intlShape, defineMessages} from 'react-intl';
import VM from 'scratch-vm';
import randomizeSpritePosition from '../lib/randomize-sprite-position';
import spriteTags from '../lib/libraries/sprite-tags';

import LibraryComponent from '../components/library/library.jsx';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Sprite',
        description: 'Heading for the sprite library',
        id: 'gui.spriteLibrary.chooseASprite'
    }
});

class SpriteLibrary extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
        this.state = {
            spriteLibraryContent: [],
            loading: true,
            error: null
        };
    }
    
    async componentDidMount() {
        try {
            // API呼び出しは直接Next.jsへ、アセット取得はWorker経由
            const apiHost = process.env.API_HOST || 'http://localhost:3000';
            const url = `${apiHost}/api/sprites/available`;
            
            
            const response = await fetch(url);
            
            if (!response.ok) {
                throw new Error(`Failed to fetch available sprites: ${response.status}`);
            }
            
            const spriteLibraryContent = await response.json();
            
            this.setState({ 
                spriteLibraryContent, 
                loading: false 
            });
        } catch (error) {
            console.error('Error loading available sprites:', error);
            this.setState({ 
                error: error.message, 
                loading: false 
            });
        }
    }
    handleItemSelect (item) {
        // Randomize position of library sprite
        randomizeSpritePosition(item);
        this.props.vm.addSprite(JSON.stringify(item)).then(() => {
            this.props.onActivateBlocksTab();
        });
    }
    render () {
        if (this.state.loading) {
            return (
                <LibraryComponent
                    data={[]}
                    id="spriteLibrary"
                    tags={spriteTags}
                    title="Loading sprites..."
                    onItemSelected={this.handleItemSelect}
                    onRequestClose={this.props.onRequestClose}
                />
            );
        }
        
        if (this.state.error) {
            return (
                <LibraryComponent
                    data={[]}
                    id="spriteLibrary"
                    tags={spriteTags}
                    title={`Error: ${this.state.error}`}
                    onItemSelected={this.handleItemSelect}
                    onRequestClose={this.props.onRequestClose}
                />
            );
        }
        
        
        return (
            <LibraryComponent
                data={this.state.spriteLibraryContent}
                id="spriteLibrary"
                tags={spriteTags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

SpriteLibrary.propTypes = {
    intl: intlShape.isRequired,
    onActivateBlocksTab: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

export default injectIntl(SpriteLibrary);